var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAsset30(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 608.21 618.04",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#8d2168;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_6",
    "data-name": "Layer 6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M600.93,365.85S653.93,99,473.93,49-55.78-94,7.58,375l31.7,36S220.93-207.35,600.93,365.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M600.93,365.85l-31.7,59.79S548.66,285.55,511.3,247.79L578.73,226Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M140.14,213.47s-3.27,47.75-13.57,54.16c0,0,167.31-92.65,209.51-141.12s-85.19-46.18-85.19-46.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M298.05,10.5S543.1-50.23,570.19,120.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M7.58,375s17.7,227,46.7,243C54.28,618,30.75,420,74,322.51s-27.55-64.15-27.55-64.15Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsset30);
export default __webpack_public_path__ + "static/media/Asset 30.08c450be.svg";
export { ForwardRef as ReactComponent };